import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';

import { getStateSelectedVehicle } from '../../+store/vehicles';
import { Vehicle } from '../../models/vehicle-data';
import { IOOEOrder, IOOEUserState } from '../../models/userState.model';
import { takeUntil } from 'rxjs/operators';
import { getActiveOrderHeader } from '../../+store/customers/customers.selectors';
import { LoadActiveOrderHeader } from '../../+store/customers/customers.actions';
import { IMainState } from '../../+store';
import { OOESessionService } from '../../../../../../../../libs/core-ui/src/lib/services/ooe-session.service';
import { CoreUiPartialState, getArbCentralNavSecurity, MessageService } from '@pos-app/core-ui';

@Component({
    selector: 'app-order-status-bar',
    templateUrl: './order-status-bar.component.html',
    styleUrls: ['./order-status-bar.component.scss'],
    standalone: false
})
export class OrderStatusBarComponent implements OnInit, OnDestroy {
  public selectedVehicle$: Observable<Vehicle>;
  public activeOrderHeader$: Observable<any>;
  arbCentralSecurityFunctions$: Observable<boolean>;

  // local copy to ensure change-detection sees updates when session updates arrive
  public openOrderLocal: IOOEOrder;

  public get isUserloggedIn(): boolean {
    return this.ooeSessionService.loginedSession != null;
  }

  public get hasActiveOrder(): boolean {
    return !!this.openOrderLocal?.orderNumber || this.ooeSessionService.hasActiveOrder;
  }

  public get ooeUserState(): IOOEUserState {
    return this.ooeSessionService.getOOEUserState();
  }

  public get openOrder(): IOOEOrder {
    return this.openOrderLocal || this.ooeSessionService.openOrder;
  }

  public get orderValue(): string {
    const value = this.openOrder?.orderValue;
    const num = typeof value === 'number' ? value : Number(value);
    return (!isNaN(num) ? num : 0).toFixed(2);
  }

  private componentDestroyed$ = new Subject<void>();

  constructor(
    private messageService: MessageService,
    private store: Store<IMainState>,
    private ooeSessionService: OOESessionService,
    private coreUiStore: Store<CoreUiPartialState>
  ) {}
  public ngOnInit(): void {
    this.activeOrderHeader$ = this.store.select(getActiveOrderHeader);
    this.selectedVehicle$ = this.store.select(getStateSelectedVehicle);
    this.arbCentralSecurityFunctions$ = this.coreUiStore.select(getArbCentralNavSecurity);

    // Keep local openOrder in sync with session updates (FetchUserState, or manual session updates)
    this.ooeSessionService.ooeUserState$.pipe(takeUntil(this.componentDestroyed$)).subscribe((res) => {
      if (res && res.OpenOrder) {
        this.openOrderLocal = res.OpenOrder;
      }
    });

    this.messageService
      .listen('orderUpdated')
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(() => {
        // When an order update occurs, request the latest user state which contains OpenOrder.orderValue.
        if (this.ooeSessionService.hasActiveOrder) {
          // Call fetchUserState to refresh OpenOrder in session. Product components already call this in some flows, but ensure it here as a fallback.
          this.ooeSessionService
            .fetchUserState()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((res) => {
              if (res && res.OpenOrder) {
                this.openOrderLocal = res.OpenOrder;
              }
            });

          // Also refresh the order header in the customers store (existing behavior)
          this.loadOrderHeader();
        }
      });
  }

  public ngOnDestroy(): void {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }

  public loadOrderHeader(): void {
    if (this.ooeSessionService.hasActiveOrder) {
      this.store.dispatch(
        LoadActiveOrderHeader({
          payload: {
            orderNumber: this.openOrder.orderNumber,
          },
        })
      );
    }
  }

  public hasValidOrderTypes(): boolean {
    const session = JSON.parse(localStorage.getItem('jdeSession'));
    var returnV = true;
    if (!session || !session.ValidOrderTypes || session.ValidOrderTypes.length <= 0) returnV = false;
    return returnV;
  }
}

